/**
 *
 * 时间戳转时间
 * @update 2019年9月12日
 * @param { dateTime } date -时间戳
 * @param { String } fmt    -格式化格式
 * formatDate(newTime,'yyyy-MM-dd hh:mm')   //2017-12-27 19:37
 *
 * */
import moment from 'moment';

export function formatDate(date, fmt) {
  date = new Date(date);
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  };
  // 遍历这个对象
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = `${o[k]}`;
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
}

// 多久之前
/**
 *
 * 时间戳转时间
 * @update 2019年9月12日
 * @param { dateTime } date -时间戳
 * @param { String } fmt    -格式化格式
 * @param { String } diff    -差值
 * @param { String } type    -差值类型  year/month/day
 * formatDateBefore(newTime,'yyyy-MM-dd hh:mm')   //2017-12-27 19:37
 * 注：原则上diff不允许为负数
 * */

export function formatDateBefore(date, fmt, diff, type) {
  let month;
  if (type === 'day') {
    date = new Date(date - diff * 24 * 60 * 60 * 1000);
  } else {
    date = new Date(date);
  }
  // diff < 0
  if (diff < 0) {
    if (/(y+)/.test(fmt)) {
      let afterDiff;
      month = date.getMonth() * 1 + 1;
      if (type === 'month') {
        // diff后的月份
        if (date.getMonth() * 1 + 1 - diff * 1 > 12) {
          afterDiff = -parseInt((date.getMonth() * 1 + 1 - diff * 1) / 12);
        } else {
          afterDiff = 0;
        }
        if (date.getMonth() * 1 + 1 - diff * 1 === 12) {
          month = 12;
          afterDiff = 0;
        } else {
          month = (date.getMonth() * 1 + 1 - diff * 1) % 12;
          afterDiff = -parseInt((date.getMonth() * 1 + 1 - diff * 1) / 12);
        }
        // diff后的年份差值（+）
      } else if (type === 'year') {
        afterDiff = diff;
      } else {
        afterDiff = 0;
      }
      fmt = fmt.replace(
        RegExp.$1,
        `${date.getFullYear() - afterDiff * 1}`.substr(4 - RegExp.$1.length),
      );
    }
  } else {
    // diff >= 0
    // 计算年的值
    if (/(y+)/.test(fmt)) {
      let beforeDiff;
      if (type === 'year' && date.getMonth() < 11) {
        beforeDiff = diff;
      } else if (type === 'month') {
        // diff >= 12并且取模之后的值大于当前月份
        if ((diff % 12) - 1 > date.getMonth() && parseInt(diff / 12) > 0) {
          beforeDiff = parseInt(diff / 12) + 1;
          // diff < 12并且取模之后的值大于当前月份
        } else if ((diff % 12) - 1 > date.getMonth() && parseInt(diff / 12) <= 0) {
          beforeDiff = 1;
          // diff >= 12并且取模之后的值小于于当前月份
        } else if ((diff % 12) - 1 < date.getMonth() && parseInt(diff / 12) > 0) {
          beforeDiff = parseInt(diff / 12);
          // diff < 12并且取模之后的值小于当前月份
        } else if ((diff % 12) - 1 < date.getMonth() && parseInt(diff / 12) <= 0) {
          beforeDiff = 0;
          // diff取模之后的值等于当前月份
        } else if ((diff % 12) - 1 === date.getMonth() * 1) {
          beforeDiff = parseInt(diff / 12) + 1;
        } else {
          beforeDiff = 0;
        }
      } else {
        beforeDiff = 0;
      }
      fmt = fmt.replace(
        RegExp.$1,
        `${date.getFullYear() - beforeDiff}`.substr(4 - RegExp.$1.length),
      );
    }
    // 计算月的值
    if (type === 'year' && diff > 0) {
      month = date.getMonth() < 11 ? date.getMonth() + 2 : date.getMonth() - 10;
    } else if (type === 'month') {
      diff = diff % 12;
      if (diff - 1 > date.getMonth()) {
        month = date.getMonth() * 1 + 13 - diff;
      } else if (diff - 1 < date.getMonth()) {
        month = date.getMonth() * 1 + 1 - diff;
      } else {
        month = 12;
      }
    } else {
      month = date.getMonth() + 1;
    }
  }
  const o = {
    'M+': month,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  };
  // 遍历这个对象
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = `${o[k]}`;
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return `00${str}`.substr(str.length);
}

/**
 *
 * 时间戳转相差时间时间
 * @update 2019年9月12日
 * @param { begintime } date    -开始时间戳
 * @param { endtime }   fmt     -结束时间戳
 * formatDate(newTime,'yyyy-MM-dd hh:mm')   //2017-12-27 19:37
 *
 * */
export function selectDay(begintime = new Date().getTime(), endtime = new Date().getTime()) {
  const nTime = endtime - begintime;
  const day = Math.floor(nTime / 86400000);
  return day;
}

/**
 * @description: 将时间戳转换成时分秒
 * @param {Number} timeStamp
 * @return {object}
 * @author: lijinpeng
 */
export const getHMSByTimeStamp = timeStamp => {
  const secondTimeStamp = 1000;
  const minuteTimeStamp = 1000 * 60;
  const hoursTimeStamp = 1000 * 60 * 60;
  // 多少小时
  const hours = Math.floor(timeStamp / hoursTimeStamp);
  // 多少分钟
  const minute = Math.floor((timeStamp - hours * hoursTimeStamp) / minuteTimeStamp);
  // 多少秒
  const second = Math.floor(
    (timeStamp - (hours * hoursTimeStamp + minute * minuteTimeStamp)) / secondTimeStamp,
  );
  return {
    hours,
    minute,
    second,
  };
};

/**
 * @description: 时分秒倒计时文案
 * @param {*}
 * @return {*}
 * @author: lijinpeng
 */
export const getHMSCountDownText = diffTimeStamp => {
  const { hours, minute, second } = getHMSByTimeStamp(diffTimeStamp);
  const hourText = hours && hours > 0 ? `${hours}小时` : '';
  const minuteText = minute && minute > 0 ? `${minute}分钟` : '';
  const secondText = second && second > 0 ? `${second}秒` : '';
  return `${hourText}${minuteText}${secondText}`;
};

/**
 *  选取每月第一天
 * @des loading
 * @param date 有效的时间
 */
export function formatMonthFirstDay(date) {
  const year = new Date(date).getFullYear();
  const month = new Date(date).getMonth() + 1;
  const dateNew = `${year}-${month}-1`;
  return new Date(dateNew).getTime();
}

/**
 *  选取每月最后一天
 * @des loading
 * @param date 有效的时间
 */
export function formatMonthLastDay(date) {
  const year = new Date(date).getFullYear();
  let month = new Date(date).getMonth() + 1;
  if (month < 12) {
    month = month * 1 + 1;
    const dateNew = `${year}-${month}-1`;
    return new Date(dateNew).getTime() - 1;
  } else {
    return new Date(`${year}-${12}-31 :23:59:59`).getTime();
  }
}

export function getNowFormatDate() {
  const date = moment().add(-1, 'days')._d;
  var seperator1 = '-';
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = `0${month}`;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = `0${strDate}`;
  }
  var currentdate = `${year}年${month}月${strDate}日`;
  return currentdate;
}
